import { useMapContext } from '../../contexts/mapContext';
import { useEffect } from 'react';
import {
	MAP_SOURCE_NAME,
	CLUSTERED_SELECTED_FEATURE_PROPERTY,
	SELECTED_FEATURE_PROPERTY,
} from '../../constants/mapConstants';
import { EMPTY_FEATURE_COLLECTION } from '../../constants/emptyFeatureCollection';

export default function useSource() {
	const [{ map, rawData }] = useMapContext();

	useEffect(() => {
		if (!map) return;
		const oldSource = map.getSource(MAP_SOURCE_NAME);
		if (oldSource) map.removeSource(MAP_SOURCE_NAME);
		map.addSource(MAP_SOURCE_NAME, {
			type: 'geojson',
			data: EMPTY_FEATURE_COLLECTION,
			cluster: true,
			clusterProperties: {
				[CLUSTERED_SELECTED_FEATURE_PROPERTY]: ['+', ['get', SELECTED_FEATURE_PROPERTY]],
			},
			generateId: true,
		});
		return () => {};
	}, [map]);

	useEffect(() => {
		if (!map || !rawData) return;
		const source = map.getSource(MAP_SOURCE_NAME);
		if (!source) return;
		source?.setData(rawData);
	}, [rawData, map]);
}
